import bilAPI from '../api';

export const postAttempt = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/exam/account_exam_attempt/', body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchAttempt = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/exam/account_exam_attempt/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
